import React, { createContext, useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import useControlled from '../../utils/useControlled'
import useId from '../../utils/useId'
import FormGroup from '../FormGroup/FormGroup'
import RadioGroupContext from './RadioGroupContext'

export default function RadioGroup(props) {
	const { children, name: nameProp, value: valueProp, onChange, ...other } = props

	const [value, setValueState] = useControlled({
		controlled: valueProp,
		default: Boolean(props.defaultValue)
	})

	const handleChange = (event) => {
		setValueState(event.target.value)

		if (onChange) {
			onChange(event, event.target.value)
		}
	}

	const name = useId(nameProp)

	return (
		<RadioGroupContext.Provider value={{ name, onChange: handleChange, value }}>
			<FormGroup role="radiogroup" {...other}>
				{children}
			</FormGroup>
		</RadioGroupContext.Provider>
	)
}

RadioGroup.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * The default `input` element value. Use when the component is not controlled.
	 */
	defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string]),
	/**
	 * The name used to reference the value of the control.
	 * If you don't provide this prop, it falls back to a randomly generated name.
	 */
	name: PropTypes.string,
	/**
	 * Callback fired when a radio button is selected.
	 *
	 * @param {object} event The event source of the callback.
	 * You can pull out the new value by accessing `event.target.value` (string).
	 */
	onChange: PropTypes.func,
	/**
	 * Value of the selected radio button. The DOM API casts this to a string.
	 */
	value: PropTypes.any
}
